import React from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import MarketplaceLayout from '../marketplace/MarketplaceLayout';
import { useLanguage } from '@/i18n/LanguageContext';
import './LearnLayout.css';

const LearnLayout = () => {
  const { t } = useLanguage();
  const location = useLocation();

  const learnContent = (
    <div className="learn-submenu">
      <div className="nav-container">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-8">
            <NavLink
              to="/learn"
              end
              className={({ isActive }) =>
                isActive
                  ? 'text-indigo-600 border-indigo-500 inline-flex items-center px-1 py-3 border-b-2 text-sm font-medium'
                  : 'text-gray-500 hover:text-gray-700 hover:border-gray-300 inline-flex items-center px-1 py-3 border-b-2 border-transparent text-sm font-medium'
              }
            >
              {t('learn.layout.dashboard') || 'Bảng điều khiển'}
            </NavLink>
            <NavLink
              to="/learn/my-courses"
              className={({ isActive }) =>
                isActive
                  ? 'text-indigo-600 border-indigo-500 inline-flex items-center px-1 py-3 border-b-2 text-sm font-medium'
                  : 'text-gray-500 hover:text-gray-700 hover:border-gray-300 inline-flex items-center px-1 py-3 border-b-2 border-transparent text-sm font-medium'
              }
            >
              {t('learn.layout.myCourses') || 'Khoá học của tôi'}
            </NavLink>
            <NavLink
              to="/learn/certificates"
              className={({ isActive }) =>
                isActive
                  ? 'text-indigo-600 border-indigo-500 inline-flex items-center px-1 py-3 border-b-2 text-sm font-medium'
                  : 'text-gray-500 hover:text-gray-700 hover:border-gray-300 inline-flex items-center px-1 py-3 border-b-2 border-transparent text-sm font-medium'
              }
            >
              {t('learn.layout.certificates') || 'Chứng chỉ'}
            </NavLink>
          </nav>
        </div>
      </div>
      <div className="py-6 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <Outlet />
      </div>
    </div>
  );

  return <MarketplaceLayout children={learnContent} />;
};

export default LearnLayout; 